export enum ChartTypes { Donut, Bar, Waterfall }
